import React from 'react';
import styled from 'styled-components';

// --- STYLED COMPONENTS (with modifications) ---

const PageHeader = styled.div`
    background-image: linear-gradient(rgba(42, 125, 225, 0.7), rgba(42, 125, 225, 0.7)), url('/services-banner-2.png');
    background-size: cover;
    background-position: center;
    padding: 12rem 2rem;
    text-align: center;
    position: relative;
`;

const PageTitle = styled.h1`
    font-size: 3rem;
    color: #fff;
    margin-bottom: 1rem;
`;

const PageSubtitle = styled.p`
    font-size: 1.2rem;
    color: #fff; /* Changed from #f0f0f0 to pure white */
    max-width: 600px;
    margin: 0 auto;
`;


const ServicesContainer = styled.section`
    padding: 4rem 2rem;
    max-width: 1100px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 4rem; // Space between service cards
`;

const ServiceCard = styled.div`
    display: flex;
    align-items: center;
    gap: 2.5rem;
    background-color: #fff;
    padding: 2rem;
    border-radius: 10px;
    box-shadow: 0 5px 20px rgba(0,0,0,0.07);

    &:nth-child(odd) {
        flex-direction: row-reverse;
    }

    @media (max-width: 768px) {
        flex-direction: column !important;
        text-align: center;
    }
`;

const ImageContainer = styled.div`
    flex: 1;
    min-width: 300px;

    img {
        width: 100%;
        border-radius: 8px;
        display: block;
    }
`;

const TextContainer = styled.div`
    flex: 1.5;
`;

const ServiceTitle = styled.h2`
    font-size: 2rem;
    color: #2a7de1;
    margin-bottom: 1rem;
`;

const ServiceDescription = styled.p`
    font-size: 1.1rem;
    line-height: 1.7;
    color: #444;
`;



const Services = () => {
    return (
        <>
            <PageHeader>
                <PageTitle>Our ABA Therapy Services</PageTitle>
                <PageSubtitle>
                    Personalized, evidence-based care in the environment that best suits your child's needs.
                </PageSubtitle>
            </PageHeader>

            <ServicesContainer>
                {/* Home Therapy Service */}
                <ServiceCard>
                    <ImageContainer>
                        <img src="/at-home.png" alt="Therapist working with a child in a comfortable home setting" />
                    </ImageContainer>
                    <TextContainer>
                        <ServiceTitle>Home Therapy</ServiceTitle>
                        <ServiceDescription>
                            A child can receive his ABA services in the comfort and familiarity of their own home. A dedicated therapist will work with you to create a weekly schedule to meet at your house, integrating therapy into your family's daily routines for natural, effective learning.
                        </ServiceDescription>
                    </TextContainer>
                </ServiceCard>

                {/* Center Therapy Service */}
                <ServiceCard>
                    <ImageContainer>
                        <img src="/in-center.png" alt="A bright and child-friendly therapy center with equipment" />
                    </ImageContainer>
                    <TextContainer>
                        <ServiceTitle>Center-Based Therapy</ServiceTitle>
                        <ServiceDescription>
                            Your child can join us at our welcoming, state-of-the-art facility. The center is equipped with a wide range of therapeutic tools and resources designed to help your child learn new skills in a structured, supportive, and engaging social environment.
                        </ServiceDescription>
                    </TextContainer>
                </ServiceCard>
            </ServicesContainer>
        </>
    );
};

export default Services;